import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { allTypesUrl } from "@temp/app/routes";
import * as React from "react";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";
import { Button } from "../..";
import cartRed from "../../../images/cart-red.svg";
import sadSmile from "../../../images/sad-smile.svg";

var Empty = function Empty(_ref) {
  var overlayHide = _ref.overlayHide;
  var intl = useIntl();
  return React.createElement("div", {
    className: "cart__empty"
  }, React.createElement("div", {
    className: "cart__empty-img"
  }, React.createElement("img", {
    src: sadSmile,
    alt: "Sad"
  }), React.createElement("img", {
    src: cartRed,
    alt: "Cart is empty"
  })), React.createElement("p", {
    className: "cart__empty-text"
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "Oops... Your cart is empty!",
    "id": "components.OverlayManager.Cart.Empty.815711149"
  }, "id", "components.OverlayManager.Cart.Empty.815711149"))), React.createElement("div", {
    className: "cart__empty__action"
  }, React.createElement(Link, {
    to: allTypesUrl
  }, React.createElement(Button, {
    secondary: true,
    onClick: overlayHide,
    className: "red"
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "shop now",
    "id": "components.OverlayManager.Cart.Empty.2329861766"
  }, "id", "components.OverlayManager.Cart.Empty.2329861766"))))));
};

export default Empty;